/**
 * Analytics utility functions
 * All tracking only fires on production (app.pollbolt.com)
 */

/**
 * Track signup conversion for Google Ads and GA4
 * Only fires on production
 * @param {string} method - The signup method ('email' or 'google')
 */
export const trackSignupConversion = (method = 'email') => {
  const isProduction = window.location.hostname === 'app.pollbolt.com';
  
  if (!isProduction) {
    return;
  }

  // Check if gtag is available (loaded from index.html)
  if (typeof window.gtag !== 'function') {
    console.warn('[Analytics] gtag not available');
    return;
  }

  // Google Ads conversion
  window.gtag('event', 'conversion', {
    'send_to': 'AW-17794360136/tbeBCOOrns8bEMjGgaVC',
    'value': 1.0,
    'currency': 'ILS'
  });

  // GA4 sign_up event
  window.gtag('event', 'sign_up', {
    method: method
  });

};

/**
 * Track first survey created event for GA4
 * Only fires on production
 * @param {string} surveyId - The ID of the created survey
 */
export const trackFirstSurveyCreated = (surveyId) => {
  const isProduction = window.location.hostname === 'app.pollbolt.com';
  
  if (!isProduction) {
    return;
  }

  // Check if gtag is available (loaded from index.html)
  if (typeof window.gtag !== 'function') {
    console.warn('[Analytics] gtag not available');
    return;
  }

  // GA4 first_survey_created event
  window.gtag('event', 'first_survey_created', {
    survey_id: surveyId
  });

};
